var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ColumnContainer',{staticClass:"FlowEditorColumnContainer"},[_c('FlowSelector'),_c('TriggerEditor',{attrs:{"cards":_vm.triggers}}),_c('ConditionEditor',{attrs:{"cards":_vm.conditions}}),_c('ActionEditor',{attrs:{"cards":_vm.actions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }